module.exports = __webpack_public_path__ + "static/media/icome-expense.bcb2977b.png";